import MojitoCore from 'mojito/core';

const log = MojitoCore.logger.get();

/**
 * Abstract sharing service to be implemented by different integrations.
 * Note: All methods must be implemented in an asynchronous way and return promise.
 *
 * @class AbstractSharingService
 * @abstract
 * @memberof Mojito.Services.Sharing
 */
export default class AbstractSharingService {
    /**
     * Configure service instance.
     *
     * @param {object} config - Service configuration object.
     *
     * @function Mojito.Services.Sharing.SharingService#configure
     */
    // eslint-disable-next-line no-unused-vars
    configure(config) {
        // To be implemented by subclasses
    }

    /**
     * Copies text to clipboard.
     *
     * @param {string} text - The text to copy.
     *
     * @returns {Promise} Promise that resolves when the text is copied or rejects on error.
     * @function Mojito.Services.Sharing.AbstractSharingService#copyTextToClipboard
     */
    // eslint-disable-next-line no-unused-vars
    copyTextToClipboard(text) {
        log.error('copyTextToClipboard must be implemented by concrete subclass');
        return Promise.reject();
    }

    /**
     * Shares object via {@link: https://developer.mozilla.org/en-US/docs/Web/API/Web_Share_API|Web Share API}.
     *
     * @param {object} data - The data to share.
     *
     * @returns {Promise} Promise that resolves when the data is shared or rejects on error.
     * @function Mojito.Services.Sharing.AbstractSharingService#shareUrl
     */
    // eslint-disable-next-line no-unused-vars
    webShare(data) {
        log.error('webShare must be implemented by concrete subclass');
        return Promise.reject();
    }

    /**
     * Share an image based on base64-encoded data URL of the image.
     *
     * @param {string} dataUrl - The data URL for image.
     * @param {string} fileName - The file name for image.
     *
     * @returns {Promise} Promise that resolves when the image is shared or rejects on error.
     * @function Mojito.Modules.Services.Sharing.AbstractSharingService#shareImage
     */
    // eslint-disable-next-line no-unused-vars
    shareImage(dataUrl, fileName) {
        log.error('shareImage must be implemented by concrete subclass');
        return Promise.reject();
    }
}
